import React from "react";
import Main from "./components/Main";
import Error from "./components/Error";

export const routes = [
    { path: "/", element: <Main /> },
    { path: "/error", element: <Error /> },
    { path: "/multi_request_error", element: <Error errorText="MULTIPLE_REQUEST_ERROR.INFO" /> },
    { path: "/user_setup_error", element: <Error errorText="USER_SETUP_ERROR.INFO" /> },
]; 